import {
  TcuSlot,
  GetTcuAvailableSlotsPayload,
} from "../getTcuAvailableSlot.fromApi.types";
import {
  TcuAvailableSlot,
  TcuSlotDetails,
} from "../getTcuAvailableSlots.toUi.types";

const mapApiDataToProps = (
  payload: GetTcuAvailableSlotsPayload | null,
): TcuAvailableSlot[] => {
  if (!payload) {
    return [];
  }

  const mapSlots = (slots: TcuSlot[]): TcuSlotDetails[] => {
    return slots.map((slot: TcuSlot) => ({
      id: slot.SlotId,
      date: slot.Start,
      serviceType: slot.ResourceId || "",
    }));
  };

  if (payload.Slots && payload.Slots.length > 0) {
    return payload.Slots.map((slot: TcuSlot) => ({
      slots: mapSlots([slot]),
    }));
  } else if (payload.LinkedSlots && payload.LinkedSlots.length > 0) {
    return payload.LinkedSlots.map((slots: TcuSlot[]) => ({
      slots: mapSlots(slots),
    }));
  }

  return [];
};

export { mapApiDataToProps };
